import { useTranslation } from '@exam-room/translations';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { Header } from '../../../../components';
import { useAuth, useNewExam } from '../../../../providers';
import { PATHS } from '../../../constants';
import { ExamTimer } from '../../components';

interface ExamPreviewHeaderProps {
  menus: JSX.Element[];
  withTimer?: boolean;
}

export default function ExamPreviewHeader(props: Readonly<ExamPreviewHeaderProps>) {
  const { menus, withTimer = true } = props;

  const navigate = useNavigate();
  const { taskId } = useParams();
  const { loading, examTime } = useNewExam();

  const handleSubmitExam = async () => {
    navigate(generatePath(PATHS.Preview.Completed, { taskId }), {
      state: true,
    });
  };

  const shouldShowTimer =
    withTimer && examTime?.endedAt instanceof Date && examTime?.startedAt instanceof Date;

  return (
    <Header
      left={
        <div className='flex items-center gap-4'>
          <img src='/logo.svg' alt='logo' className='h-10' />
        </div>
      }
      middle={
        shouldShowTimer ? (
          <ExamTimer
            loading={loading}
            onSubmit={handleSubmitExam}
            examStartedAt={examTime?.startedAt as Date}
            examEndedAt={examTime?.endedAt as Date}
          />
        ) : null
      }
      right={<div className='flex items-center gap-2'>{menus}</div>}
    />
  );
}
